/**
 * GTG（Googleタグゲートウェイ）用にサイト側で予約し、GTM 管理画面に登録した計測パス
 * コンテナごとに一意で、インフラ側のプロキシ設定と一致させる必要がある
 * @note 末尾スラッシュはスニペット側で付与するため、この定数には含めない
 * （含めると `//?id=` になる）
 */
const GTG_PATH = "/gtg-5db81824";

const GTM_CONTAINER_ID = "GTM-KKDRT9";

/**
 * GTG経由でGTMを読み込むローダースニペット
 * @note
 * - ルート相対URLにしているため、配信オリジンごとに正しいゲートウェイへ解決される。
 *   絶対URLにすると stg のページが本番ドメインのゲートウェイへリクエストしてしまう
 *   （`pathPrefix: "/lp"` は文字列に埋め込むだけの本スニペットには適用されないため、
 *   `/lp/gtg-5db81824/` ではなくオリジン直下に解決される）
 * - `?id=` が空なのは Google 発行スニペットと同じ形。ゲートウェイは計測パスだけで
 *   コンテナを解決するため URL にコンテナIDを含めない。公式は IIFE 第 5 引数に
 *   空文字を渡す形だが、常に空なら渡す意味がないため本実装では引数自体を省いている
 * - `dataLayer` という名前はアプリ側の `window.dataLayer.push` と一致させる必要がある
 * @see https://developers.google.com/tag-platform/tag-manager/gateway/setup-guide?setup=manual
 */
export const GTG_SNIPPET = `(function(w,d,s,l){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
j.src='${GTG_PATH}/?id='+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer');`;

/**
 * noscript フォールバック用の iframe
 * @note GTG は noscript スニペットをサポートしないため、GTG経由にせず標準の
 * googletagmanager.com を継続利用する。こちらはコンテナIDを URL に含める必要がある
 * @see https://developers.google.com/tag-platform/tag-manager/gateway/setup-guide?setup=manual
 */
export const GTM_NOSCRIPT_IFRAME = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>`;

/**
 * ルート遷移時に dataLayer へ push するイベント名
 * @note GTM のトリガー名と一致させる必要がある
 */
export const GTM_ROUTE_CHANGE_EVENT = "gatsby-route-change";
